import { Form, Select } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { FormItemProps } from "antd/lib/form";
import { getDirList } from "../api";

const IndicatorFolderSelector: React.FC<FormItemProps<any>> = (props) => {
  const [folderList, setFolderList] = useState<{ id: number; name: string }[]>(
    []
  );

  useEffect(() => {
    getDirList().then((res) => {
      if (res && Array.isArray(res)) {
        setFolderList(res);
      }
    });
  }, []);

  const options = useMemo(() => {
    return folderList.map((d) => (
      <Select.Option key={d.id + ""} value={d.id + ""}>
        {d.name}
      </Select.Option>
    ));
  }, [folderList]);

  return (
    <Form.Item {...props}>
      <Select
        showSearch
        placeholder="文件夹"
        style={{ width: 200 }}
        defaultActiveFirstOption={false}
        showArrow={true}
        filterOption={false}
        notFoundContent={null}
        allowClear
      >
        {options}
      </Select>
    </Form.Item>
  );
};

export default IndicatorFolderSelector;
